module.exports = __webpack_public_path__ + "img/mexico869.efc8110f.jpg";